export default function AlbertaCroupSeverityComponent() {
  return <></>;
}
